import Vue from 'vue';
import VueRouter from 'vue-router';

import CyberMerit from '../components/Main/CyberMerit/CyberMerit.vue'
import LifeRemaker from '../components/Main/LifeRemaker/LifeRemaker.vue'
import MiniList from '../components/Main/MiniList/MiniList.vue'

Vue.use(VueRouter);
let originPush = VueRouter.prototype.push;
VueRouter.prototype.push = function (location, resolve, reject) {
  if (resolve && reject) {
    originPush.call(this, location, resolve, reject);
  }
  else {
    originPush.call(this, location, () => { }, () => { });
  }
}

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      name: 'index',
      path: '/index',
      component: MiniList,
    },
    {
      name: 'cybermerit',
      path: 'cybermerit',
      component: CyberMerit,
    },
    {
      name: 'liferemaker',
      path: 'liferemaker',
      component: LifeRemaker
    }
  ]
})

export default router;